<template>
  <div>
    <v-card>
      <v-form ref="form" class="multi-col-validation">
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">CHANGE BRANCH OR POSITION</h4>
          </v-toolbar-title>
        </v-toolbar>

        <v-layout row wrap class="align-center mx-2 mt-5">
          <v-flex xs12 md12>
            <v-text-field
              class="mx-2"
              v-model="date_released"
              dense
              label="Date Effective"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
              type="date"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md12>
            <v-select
              class="mx-2 mt-3"
              v-model="category_id"
              dense
              label="Category"
              :items="category_items"
              item-value="id"
              item-text="category"
              :rules="rules.combobox_rule"
              @change="selected_category"
              outlined
            ></v-select>
            <v-select
              class="mx-2 mt-3"
              v-model="branch_id2"
              dense
              label="Department/Branch"
              :items="branch_items2"
              item-value="id"
              item-text="branch_code"
              :rules="rules.combobox_rule"
              outlined
              @change="selected_branch2"
            ></v-select>
            <v-select
              class="mx-2 mt-3"
              v-model="branch_id"
              dense
              label="Division"
              :items="branch_items"
              item-value="id"
              item-text="branch_code"
              :rules="rules.combobox_rule"
              outlined
              @change="selected_branch"
            ></v-select>
            <v-select
              v-model="renumeration"
              class="mx-2 mt-3"
              dense
              outlined
              item-value="renumeration"
              item-text="renumeration"
              label="Renumeration"
              :items="renumeration_items"
              :rules="rules.combobox_rule"
              @change="selected_renumeration"
            ></v-select>
            <v-select
              class="mx-2 mt-3"
              v-model="position_id"
              dense
              label="Position"
              :items="position_items"
              item-value="id"
              item-text="position"
              :rules="rules.combobox_rule"
              @change="selected_position"
              outlined
            ></v-select>

            <v-select
              class="mx-2 mt-3"
              v-model="salary_grade"
              dense
              label="Level"
              :items="['1','2','3','4','5']"
              :rules="rules.combobox_rule"
              outlined
            ></v-select>
            <v-select
              class="mx-2 mt-3"
              v-model="sg_type"
              dense
              label="SG Type"
              :items="['22 days','26 days']"
              :rules="rules.combobox_rule"
              outlined
            ></v-select>
          </v-flex>
        </v-layout>

        <v-row>
          <!-- alert -->
          <v-col cols="12" v-show="alert">
            <v-alert
              color="warning"
              text
              class="mb-0"
            >
              <div class="d-flex align-start">
                <v-icon color="warning">
                  {{ icons.mdiAlertOutline }}
                </v-icon>

                <div class="ms-3">
                  <p class="text-base font-weight-medium mb-1">
                    {{ alert_message }}
                  </p>
                </div>
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn
              class="w-full"
              color="primary"
              @click="done_request"
              v-if="!saving_request"
            >
              Done
            </v-btn>
            <v-progress-circular
              :size=50
              :width="5"
              color="primary"
              indeterminate
              v-else
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>
<script>

import {mdiAlertOutline} from "@mdi/js";
import {mapActions, mapGetters} from "vuex";

const initialState = () => {
  return {
    saving_request: false,
    alert: false,
    alert_message: '',

    category_id: '',
    renumeration: '',
    sg_type: '',
    salary_grade: '1',
    new_sg_no: '1',
    position_id: '',
    branch_id: '',
    branch_id2: '',
    date_released: '',

    renumeration_items: [],
    category_items: [],
    position_items: [],
    temp_position_items: [],
    branch_items: [],
    branch_items2: [],
  }
}
export default {
  props: {
    member_information: Object,
    id: Number,
  },
  setup() {
    return {
      icons: {
        mdiAlertOutline,
      },
    }
  },
  data() {
    return initialState();
  },
  async mounted() {
    await this.initialize_change_branch_position()
      .then(response => {
        this.category_items = response.data
      })
      .catch(error => {
        console.log(error)
      })
    this.category_id = await this.member_information.category_id
    await this.selected_category()
    // this.branch_id =await this.member_information.branch_id
    // this.position_id = await this.member_information.position_id
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('authentication', ['employee_id']),
  },
  methods: {
    ...mapActions('employee_change_position_branch_history', ['initialize_change_branch_position', 'change_branch_position_employee', 'renumeration_by_branch', 'list_of_position_by_renumeration']),
    ...mapActions('branch_information', ['branch_data']),
    selected_category() {
      this.temp_position_items = []
      this.position_id = ''
      this.branch_id = ''
      this.position_items = []
      this.branch_items = []
      var index = this.category_items.map(function (x) {
        return x.id;
      }).indexOf(this.category_id)
      if (index != -1) {
        if (this.category_items[index].branch[0].employee_position.length === 0) {
          if (this.category_id > 2) {
            this.temp_position_items = this.category_items[index].employee_position
            // this.position_items = this.category_items[index].employee_position
          }
        }
        this.branch_items2 = this.category_items[index].branch
        if (this.category_items[index].position_renumeration.length > 0) {
          this.renumeration_items = this.category_items[index].position_renumeration
        } else {
          this.renumeration_items.push({renumeration: 'NA'})
        }
      }
    },
    selected_branch2() {
      this.position_id = ''
      this.branch_id = ''
      this.position_items = []
      this.branch_items = []
      this.temp_position_items = []
      if (this.branch_items2.length > 0) {
        var index = this.branch_items2
          .map(function (x) {
            return x.id
          })
          .indexOf(this.branch_id2)
        if (index >= 0) {
          this.branch_items = this.branch_items2[index].division
          this.branch_items.splice(0, 0, {
            id: -1,
            branch_code: 'N/A DIVISION',
          })
          this.employee_position_id = ''
        }

      }
    },
    async selected_branch() {
      this.position_id = ''
      this.position_items = []
      this.temp_position_items = []
      if (this.branch_items2.length > 0) {
        var index = this.branch_items2
          .map(function (x) {
            return x.id
          })
          .indexOf(this.branch_id2)
        if (index >= 0) {
          if (this.branch_items2[index].employee_position.length > 0) {
            this.temp_position_items = this.branch_items2[index].employee_position
          }
          this.employee_position_id = ''
        }

        if (this.category_id === 2) {
          await this.renumeration_by_branch({branch_id: this.branch_id < 0 ? this.branch_id2 : this.branch_id})
            .then(response => {
              this.renumeration_items = response.data
            })
            .catch(error => {
              console.log(error)
            })
        }
        await this.selected_renumeration()
      }
    },
    selected_position() {
      var index = this.position_items.map(function (x) {
        return x.id;
      }).indexOf(this.position_id)
      if (index != -1) {
        this.new_sg_no = parseFloat(this.position_items[index].minimum_sg_no) + ''
      }
    },
    selected_renumeration() {
      this.position_id = ''
      this.position_items = []
      this.list_of_position_by_renumeration({
        renumeration: this.renumeration,
        category_id: this.category_id,
        branch_id: this.branch_id < 0 ? this.branch_id2 : this.branch_id,
      })
        .then(response => {
          this.position_items = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    done_request() {
      this.saving_request = true
      this.alert = false
      if (this.$refs.form.validate()) {
        const data = new FormData()
        data.append('employee_id', this.member_information.id);
        data.append('id', this.id);
        data.append('category_id', this.category_id);
        data.append('employee_id_created', this.employee_id);
        data.append('branch_id', this.branch_id < 0 ? this.branch_id2 : this.branch_id);
        data.append('employee_position_id', this.position_id);
        data.append('date_of_effective', this.date_released);
        data.append('salary_grade', this.new_sg_no);
        data.append('level', this.salary_grade);
        data.append('sg_type', this.sg_type);
        let proceed = true;
        if (this.position_items.length > 0) {
          var index = this.position_items
            .map(function (x) {
              return x.id
            })
            .indexOf(this.position_id)
          if (index >= 0) {
            if (parseFloat(this.salary_grade) > 5) {
              this.alert = true
              this.alert_message = 'Salary Grade not above 5'
              this.saving_request = false
              proceed = false
            }
          }
        }
        if (proceed) {
          this.change_branch_position_employee(data)
            .then(response => {
              this.$emit('response', response)
              this.saving_data = false
            })
            .catch(error => {
              console.log(error)
            })
        }
      } else {
        this.alert = true
        this.alert_message = 'Please Fill up the field/s'
        this.saving_request = false
      }
    },
  }
}
</script>
